<div *ngIf="!loginUsingCredentials && !this.authInfoModal.isOpen()"
     appHIDScanner
     (scannerEvent)="onScan($event)">
</div>

<app-button *ngIf="!this.isMobile"
            type="primary"
            class="credentials-button"
            (click)="onCredentialsSwitch()"
            [disabled]="isLoginInProgress">
    {{ (loginUsingCredentials ? 'auth.buttons.badge' : 'auth.buttons.credentials') | translate }}
</app-button>

<!-- Login with Credentials -->
<ng-container *ngIf="loginUsingCredentials">
    <app-login-form
        (successfulLogin)="handleLogin($event);"
        (loginFailure)="handleError($event);">
    </app-login-form>
</ng-container>
<!-- End of Login with Credentials -->

<!-- Login with Badge ID -->
<ng-container *ngIf="!loginUsingCredentials">
    <div class="input-field">
        <h5 class="modal-title">{{ 'auth.scanBadge'|translate }}</h5>
        <div class="scanner-status">
            <span *ngIf="focused"
                  class="message ok">{{ 'generic.scanner.focused' | translate }}
            </span>
            <span *ngIf="!focused"
                  class="message not-ok">{{ 'generic.scanner.notFocused' | translate }}
            </span>
        </div>
    </div>
    <div class="alert alert-danger" *ngIf="loginError">
        <strong>{{ 'generic.error' | translate }} </strong> {{ 'auth.invalidCredentialsError' | translate }}
    </div>
</ng-container>
<!-- End of Login with Badge ID -->

<div class="language-flags">
    <span>{{ 'home.select' | translate }}</span>
    <img src="/assets/i18n/en.png"
         class="img-responsive"
         (click)="translate('en')">
    <img src="/assets/i18n/ro.png"
         class="img-responsive"
         (click)="translate('ro')">
</div>

<app-loading-spinner *ngIf="isLoginInProgress"></app-loading-spinner>

<app-authentication-info-modal
    (scanEvent)="insertBoschId($event)"
    title="{{'auth.authenticationInfo' | translate}}"
    missingRoleMessage="{{'auth.missingRole' | translate}}"
    missingBoschIdMessage="{{'auth.missingBoschId' | translate}}"
    [displayScanMode]="!userHasBoschId">
</app-authentication-info-modal>

<app-password-confirm-modal
    [userIdentity]="userIdentity"
    (passwordConfirmed)="onConfirmPassword($event)">
</app-password-confirm-modal>
